import { FC, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import SeguimientoMeta from './SeguimientoMeta';
import SeguimientoCumpleMeta from './SeguimientoCumpleMeta';
import SeguimientoCierreMeta from './SeguimientoCierreMeta';
import SeguimientoFactFuvex from './SeguimientoFactFuvex';
import SeguimientoFactJefe from './SeguimientoFactJefe';
import SeguimientoFactEquipo from './SeguimientoFactEquipo';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';
import SeguimientoCanal from './SeguimientoCanal';

const Seguimiento: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const title = 'Seguimiento de Convenios';
  const defaultLimit = 10;
  const [meta, setMeta] = useState({ amount: 0, description: '' });
  const [cierre, setCierre] = useState({ amountProject: 0, amountFinish: 0 });
  const [cierreCanal, setCierreCanal] = useState({ amountProject: 0, amountFinish: 0 });
  const [cumplimiento, setCumplimiento] = useState({ amount: 0 });
  const [factTeam, setFactTeam] = useState({
    data: [],
    resume: { operaciones: 0, facturacion: 0, meta: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [factFuvex, setFactFuvex] = useState({
    data: [],
    resume: { operaciones: 0, facturacion: 0, meta: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [factRelation, setFactRelation] = useState({
    data: [],
    resume: { operaciones: 0, facturacion: 0, meta: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [valuesFilter, setValuesFilter] = useState({ year: null, month: null });

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/seguimiento',
        body: { ...values, limit: defaultLimit },
      });
      setMeta(response?.meta);
      setCierre(response?.cierre);
      setCierreCanal(response?.cierreCanal);
      setCumplimiento(response?.cumplimiento);
      setFactTeam(response?.factTeam);
      setFactFuvex(response?.factFuvex);
      setFactRelation(response?.factRelation);
    }
  };

  const handleChangePageJfn = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento/detail',
      body: {
        year,
        month,
        limit: Number(factTeam.pages.limit),
        page,
        type: 'JFN',
      },
    });
    setFactTeam(response);
  };

  const handleChangeRowsPerPageJfn = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFN',
      },
    });
    setFactTeam(response);
  };

  const handleChangePageFuvex = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento/detail',
      body: {
        year,
        month,
        limit: Number(factFuvex.pages.limit),
        page,
        type: 'FUVEX',
      },
    });
    setFactFuvex(response);
  };

  const handleChangeRowsPerPageFuvex = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'FUVEX',
      },
    });
    setFactFuvex(response);
  };

  const handleChangePageJfr = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento/detail',
      body: {
        year,
        month,
        limit: Number(factRelation.pages.limit),
        page,
        type: 'JFR',
      },
    });
    setFactRelation(response);
  };

  const handleChangeRowsPerPageJfr = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFR',
      },
    });
    setFactRelation(response);
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth />
        <Grid container spacing={2} mt={1} justifyContent="center">
          <Grid
            item
            md={6}
            xs={12}
            container
            style={{
              borderBottom: '3px dashed #e0e0e0',
              borderRight: '3px dashed #e0e0e0',
            }}
          >
            <Grid item md={5} xs={12}>
              <SeguimientoMeta meta={meta} />
            </Grid>
            <Grid item md={7} xs={12} maxHeight="250px">
              <SeguimientoCanal cierre={cierreCanal} />
            </Grid>
            <Grid item md={12} xs={12} alignSelf="flex-end">
              <Typography variant="body1" mt={4}>
                * Información Total Convenios
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            container
            style={{ borderBottom: '3px dashed #e0e0e0' }}
          >
            <Grid item md={6} xs={12}>
              <SeguimientoCierreMeta cierre={cierre} />
            </Grid>
            <Grid item md={6} xs={12}>
              <SeguimientoCumpleMeta cumplimiento={cumplimiento} />
            </Grid>
            <Grid item md={12} xs={12} alignSelf="flex-end">
              <Typography variant="body1" mt={4}>
                * Proyección de Cierre según avance de Facturación
              </Typography>
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <SeguimientoFactEquipo
              content={factTeam}
              handleChangePage={handleChangePageJfn}
              handleChangeRowsPerPage={handleChangeRowsPerPageJfn}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <SeguimientoFactJefe
              content={factRelation}
              handleChangePage={handleChangePageJfr}
              handleChangeRowsPerPage={handleChangeRowsPerPageJfr}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <SeguimientoFactFuvex
              content={factFuvex}
              handleChangePage={handleChangePageFuvex}
              handleChangeRowsPerPage={handleChangeRowsPerPageFuvex}
            />
          </Grid>
        </Grid>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(Seguimiento);
